import React from "react";
import Context from "../../Context";
import { Dropdown } from "react-bootstrap";

export default class ToolbarA extends React.Component {
  static contextType = Context;

  componentDidMount() {
    this.context.actionsSet(this.renderButtons());
  }
  componentDidUpdate() {
    this.context.actionsSet(this.renderButtons());
  }

  renderScaleDropdown = () => {
    const scales = {
      25: "25%",
      50: "50%",
      75: "75%",
      100: "100%",
      125: "125%",
      150: "150%",
    };
    return (
      <Dropdown className="d-inline-block">
        <Dropdown.Toggle
          variant="light"
          id="dropdown-basic"
          onMouseDown={(e) => {
            e.preventDefault();
          }}
        >
          {scales[this.props.currentScale]}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {Object.entries(scales).map(([value, label]) => (
            <Dropdown.Item
              key={value}
              onMouseDown={(e) => {
                e.preventDefault();
                this.props.onToggleScale(value);
              }}
              className={` ${
                this.props.currentScale === value ? "bg-secondary" : ""
              }`}
            >
              {label}
            </Dropdown.Item>
          ))}
          <Dropdown.Divider />
          <Dropdown.Item
            onMouseDown={(e) => {
              e.preventDefault();
              this.props.onToggleScale("params");
            }}
          >
            Страница ...
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  renderButtons = () => {
    return (
      <div>
        {this.props.pending ? (
          <div className="d-inline-block align-middle mr-10">
            <span className="spinner "></span>
          </div>
        ) : null}

        {this.props.onSave || this.props.onOpen || this.props.onNew ? (
          <div className="btn-group mr-2">
            {this.props.onSave ? (
              <button
                onMouseDown={(e) => {
                  e.preventDefault();
                  this.props.onSave();
                }}
                className="btn btn-light btn-icon "
              >
                <span className="fa fa-save"></span>
              </button>
            ) : null}
            {this.props.onOpen ? (
              <button
                onMouseDown={(e) => {
                  e.preventDefault();
                  this.props.onOpen();
                }}
                className="btn btn-light btn-icon "
              >
                <span className="fa fa-folder-open-o"></span>
              </button>
            ) : null}
            {this.props.onNew ? (
              <button
                onMouseDown={(e) => {
                  e.preventDefault();
                  this.props.onNew();
                }}
                className="btn btn-light btn-icon "
              >
                <span className="fa fa-file-o"></span>
              </button>
            ) : null}
          </div>
        ) : null}

        <div className="d-inline-block ">
          <div className="btn-group">
            {this.props.onPreview ? (
              <button
                onMouseDown={(e) => {
                  e.preventDefault();
                  this.props.onPreview();
                }}
                className="btn btn-light btn-icon "
              >
                <span className="fa fa-file-code-o"></span>
              </button>
            ) : null}
            {this.renderScaleDropdown()}
          </div>
        </div>
      </div>
    );
  };

  render() {
    return <></>;
  }
}
